import { ReactNode } from "react";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";

interface NotePanelProps {
  note: string;
  label?: string;
  actions?: ReactNode;
}

export function NotePanel({ note, label = "Customer Note", actions }: NotePanelProps) {
  return (
    <div className="flex items-start gap-2.5 rounded-r-md border-l-[3px] border-amber-400 bg-amber-400/10 p-2.5 dark:bg-amber-400/[0.08]">
      <ExclamationTriangleIcon className="h-[18px] w-[18px] flex-shrink-0 text-amber-400 mt-0.5" />
      <div className="flex-1">
        <div className="flex items-center justify-between">
          <div className="text-xs font-semibold text-amber-400">{label}</div>
          {actions}
        </div>
        <div className="mt-1 text-xs leading-relaxed text-gray-700 whitespace-pre-wrap dark:text-gray-300">
          {note}
        </div>
      </div>
    </div>
  );
}
